export class vendorReq{
    externalRefNo?:string
    vehicletype?:string
    constructor( externalRefNo?:string, vehicletype?:string) {
    this.externalRefNo = externalRefNo
    this.vehicletype=vehicletype

}

}